import axios from "axios";
import Config from "../../config/config";

class UserService {
    getAll() {
        return axios.get(Config.api + 'users');
    }
}

export default UserService;